export default __webpack_public_path__ + "static/video_poster_frame@2x-e231a174c35fccf30aab45604f137d43.png";